import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { Common } from 'ws-scripts/modules/common';
import { setClassNames } from 'ddc-classnames-js';

import DDCLogo from '../components/DDCLogo';
import AdChoices from '../components/AdChoices';

import '../global-sass/main.scss';

export class WidgetContainer extends React.Component {
	render() {
		const { windowId } = this.props;
		return (
			<Common
				render={({ prefs, labels }) => {
					const {
						containerClasses,
						ddcLogoColor,
						ddcLogoClasses,
						adChoicesClasses
					} = prefs;

					return (
						<div
							className={setClassNames(
								containerClasses.split(' ')
							)}
						>
							<DDCLogo
								color={ddcLogoColor}
								label={labels.get('WEBSITE_BY_DEALER_DOT_COM')}
								classes={ddcLogoClasses.split(' ')}
								windowId={windowId}
							/>
							{prefs.showAdChoices === 'true' && (
								<AdChoices
									label={labels.get('ADCHOICES')}
									classes={adChoicesClasses.split(' ')}
									windowId={windowId}
								/>
							)}
						</div>
					);
				}}
			/>
		);
	}
}

WidgetContainer.propTypes = {
	windowId: PropTypes.string.isRequired
};

const mapStateToProps = state => {
	return {
		windowId: state.requestData.windowId
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
